"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StripeElements;
var _react = _interopRequireDefault(require("react"));
var _reactStripeJs = require("@stripe/react-stripe-js");
var _stripeJs = require("@stripe/stripe-js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* global STRIPE_PUBLIC */

const stripePromise = (0, _stripeJs.loadStripe)(STRIPE_PUBLIC);
function StripeElements({
  children,
  options
}) {
  return /*#__PURE__*/_react.default.createElement(_reactStripeJs.Elements, {
    stripe: stripePromise,
    options: options
  }, children);
}